import { Action } from 'redux'
import { LimitActions } from '../../../reducers/userAccount/actionNames'

export default function(tab: number): ISetSliderTab {
  return {
    tab,
    type: LimitActions.SetSliderTab,
  }
}

export interface ISetSliderTab extends Action<LimitActions.SetSliderTab> {
  tab: number
}
